/**
 * 与后端 StpInterfaceImpl「超级管理员」一致：拥有全部菜单/接口权限的角色。
 */
export function isFullAccessRole(role: string | undefined | null): boolean {
  if (role == null || String(role).trim() === '') return false;
  const r = String(role).trim().toLowerCase();
  return r === 'admin' || r === 'super_admin';
}

/** 主角色或附加角色任一含 admin 即视为全权限（与后端 StpInterfaceImpl 一致） */
export function hasFullAccessRole(role: string | undefined | null, roles?: string[] | null): boolean {
  if (isFullAccessRole(role)) return true;
  return (roles ?? []).some((r) => isFullAccessRole(r));
}
